import React, { Suspense } from "react";
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Box, ToggleButtonGroup, ToggleButton, CssBaseline, CircularProgress } from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Header from "../elements/Header";
import MainPages from "../elements/pages/Main/MainPages";
import ServicesPages from "../elements/pages/Servicios/ServicesPages";
import VisionPages from "../elements/pages/Vision/VisionPages";
import BlogPages from "../elements/pages/Blog/BlogPages";
import ProgramPages from "../elements/pages/Trabajos/ProgramPages";
import ContactPages from "../elements/pages/Contactanos/ContactPages";
import DetallesBlogPages from "../elements/pages/Blog/DetallesBlogPages";
import Footer from "../elements/Footer";
import CertificadosPages from "../elements/pages/Certificados/CertificadosPages";
import MenuLogin from "../elements/pages/Login/MenuLogin";
import MenuRegistro from "../elements/pages/Login/MenuRegistro";
import Dashboard from "../elements/Dashboard/Dashboard";
import PrivateRoute from "./PrivateRoute";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../CSS/transitions.css'; // Importa el archivo CSS
import DetallesCertificadoPages from "../elements/pages/Certificados/DetallesCertificadoPages";
//import NotFoundPage from "../elements/NotFoundPage";

const ToggleCustomTheme = ({ showCustomTheme, toggleCustomTheme }) => {
    return(
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100dvw',
          position: 'fixed',
          bottom: 24,
        }}
      >
        <ToggleButtonGroup
          color="primary"
          exclusive
          value={showCustomTheme}
          onChange={toggleCustomTheme}
          aria-label="Platform"
          sx={{
            backgroundColor: 'background.default',
            '& .Mui-selected': {
              pointerEvents: 'none',
            },
          }}
        >
          <ToggleButton value>
            <AutoAwesomeRoundedIcon sx={{ fontSize: '20px', mr: 1 }} />
            Custom theme
          </ToggleButton>
          <ToggleButton value={false}>Material Design 2</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    );
  }
  
  ToggleCustomTheme.propTypes = {
    showCustomTheme: PropTypes.bool.isRequired,
    toggleCustomTheme: PropTypes.func.isRequired,
  };

const Rutas = () => {
    const [mode, setMode] = React.useState('light');
    const location = useLocation();
    const navigate = useNavigate();

    const toggleColorMode = () => {
      setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
    };

    const handleNavigation = (path) => {
      if (location.pathname !== path) {
        navigate(path);
      }
    };

    const showHeaderFooter = ![
      '/login', 
      '/register', 
      '/dashboard',
      '/dashboard/inicio',
      '/dashboard/contactanos',
      '/dashboard/servicio',
      '/dashboard/vision',
      '/dashboard/programa',
      '/dashboard/blog',
      '/dashboard/certificados',
    ].includes(location.pathname);

    return (
      <>
        <Helmet>
          <title>Calocho Usugha</title>
        </Helmet>
        <CssBaseline />
        {showHeaderFooter && <Header mode={mode} toggleColorMode={toggleColorMode}/>}
        <Box sx={{ bgcolor: 'background.default' }}>
          <TransitionGroup>   
            <CSSTransition
              key={location.key}
              classNames="fade"
              timeout={300}
            >
              <Suspense fallback={
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                  <CircularProgress sx={{ color: '#5d0303' }} />
                </Box>
              }>  
                <Routes location={location}>
                  <Route path="/" element={<MainPages handleNavigation={handleNavigation}/>}/>
                  <Route path='/services-page-web' element={<ServicesPages/>}/>
                  <Route path='/vision-page-web' element={<VisionPages/>}/>
                  <Route path='/certificados-page-web' element={<CertificadosPages />}/>
                  <Route path='/program-page-web' element={<ProgramPages/>}/>
                  <Route path='/blog-page-web' element={<BlogPages/>}/>
                  <Route path='/contactanos-page-web' element={<ContactPages handleNavigation={handleNavigation}/>}/>
                  <Route path='/blog-detalle/:id' element={<DetallesBlogPages />} />
                  <Route path='/certificado-detalle/:id' element={<DetallesCertificadoPages />} />
                  <Route path='/login' element={<MenuLogin />}/>
                  <Route path='/register' element={<MenuRegistro />} />

                  {/* Agrega la ruta 404 al final */}
                  {/*<Route path="/*" element={<NotFoundPage />} />*/}
                </Routes>
              </Suspense>
            </CSSTransition>
          </TransitionGroup>
          <Routes location={location}>
            <Route path='/dashboard/*' element={<PrivateRoute element={Dashboard} />} />
          </Routes>
        </Box>
        {showHeaderFooter && <Footer />}
      </>
    );
}

export default Rutas;